import Api from '@uavionix/api-client'
import { auth } from './auth'
import { authUrl, protocol } from './const'


const api = new Api({
	baseUrl: authUrl,
	protocol: protocol,
	getAuthToken: auth.getToken,
})

export default api

window.authApi = api